import { css } from "lit";

export const reset = css`
    html,
    body,
    div,
    span,
    applet,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    a,
    abbr,
    acronym,
    address,
    big,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    s,
    samp,
    small,
    strike,
    strong,
    sub,
    sup,
    tt,
    var,
    b,
    u,
    center,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    hgroup,
    menu,
    nav,
    output,
    ruby,
    section,
    summary,
    time,
    mark,
    audio,
    video,
    button,
    select,
    option,
    input {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        color: inherit;
        vertical-align: baseline;
        appearance: none;
        -webkit-appearance: none;
        scrollbar-width: thin;
    }

    ol,
    ul {
        list-style: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    th {
        text-align: unset;
    }

    /* todo: find a better solution for this, we need focus styles, elements that don't want it should opt out */
    :focus:not(ptc-ui-textarea, ptc-ui-time-input) {
        outline: 0;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type="time"]::-webkit-inner-spin-button,
    input[type="time"]::-webkit-calendar-picker-indicator,
    input[type="time"]::-webkit-clear-button {
        -webkit-appearance: none;
        margin: 0;
        display: none;
    }

    input[type="time"] {
        -webkit-appearance: none;
    }

    input[type="number"] {
        -webkit-appearance: none;
        -moz-appearance: textfield;
    }

    input[type="checkbox"] {
        -moz-appearance: checkbox;
        -webkit-appearance: checkbox;
        appearance: checkbox;
    }

    input:invalid {
        box-shadow: unset;
    }

    /*
    input:-internal-autofill-selected {
        all: unset;
    }
    */
`;
